import gql from "graphql-tag";

import { IconDetailPartsFragmentDoc } from "icons/fragments";

export const GET_ICON_CHECKOUT_PAGE_DATA = gql`
    query iconCheckoutPageData($iconId: ID!) {
        iconDetail(iconId: $iconId) {
            ...IconDetailParts
        }
    }
    ${IconDetailPartsFragmentDoc}
`;
